export const DO_CALL_FILTERS = "DO_CALL_FILTERS";
export const DO_CALL_CONVENIOS = "DO_CALL_CONVENIOS";
export const DO_CALL_TIPO_PRODUCTO_FILTER = "DO_CALL_TIPO_PRODUCTO_FILTER";
export const DO_CALL_CONVENIOS_BY_MERCHANT = "DO_CALL_CONVENIOS_BY_MERCHANT";
export const DO_AGRO_ERROR = "DO_AGRO_ERROR";
export const DO_ROUTE_PUSH_HOME = "DO_ROUTE_PUSH_HOME";
export const DO_SEND_NOTIFICATION_EMAIL = "DO_SEND_NOTIFICATION_EMAIL";
